import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CardPreview from '../common/CardPreview';
const AboutCard = () => {
    return (_jsx(CardPreview, { icon: "faUser", description: "Background, experience, and skills.", title: _jsxs(_Fragment, { children: [_jsx("span", { className: "text-text-primary", children: "About" }), '\u00A0', _jsx("span", { className: "text-text-accent", children: "Me" })] }) }));
};
export default AboutCard;
